"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const calcStepInterval = sliderValue => {
  const INTERVAL_RANGE_MS = 4500;
  const INTERVAL_EXP_FACTOR = -2.2; // evaluated in excel =4500*EXP(-2.2*A1)

  return Math.floor(INTERVAL_RANGE_MS * Math.exp(sliderValue * INTERVAL_EXP_FACTOR));
};
var _default = exports.default = calcStepInterval;